<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button (click)="scrollToTop()" class="btn btn-primary back-to-top">
    <i class="glyphicon glyphicon-menu-up"></i>
  </button>
</div>